import {
	USER_INFO,
	WORK_INFO,
	ADD_CONPANY,
	DEL_CONPANY,
	ADD_CONPANY_LIST,
	SET_CURRENT_LOGIN
} from '../constact'

const defaultState = {
	userInfo: {
		workid: ''
	},
	workInfo: {},
	companyList: [],
	currentLogin: '',

}
export function addUserInfo(data) {
	return {
		type: USER_INFO,
		data
	}
}
export function addWorkInfo(data) {
	return {
		type: WORK_INFO,
		data
	}
}
export function addCompany(data) {
	return {
		type: ADD_CONPANY,
		data
	}
}
export function delCompany(data) {
	return {
		type: DEL_CONPANY,
		data
	}
}
export function addCompanyList(data) {
	return {
		type: ADD_CONPANY_LIST,
		data
	}
}
export function setCurrentLogin(data) {
	return {
		type: SET_CURRENT_LOGIN,
		data
	}
}

const baseInfo = (state = defaultState, action) => {

	if(action.type === USER_INFO) {
		const newState = Object.assign({}, state)
		newState.userInfo = action.data
		return newState
	}
	if(action.type === WORK_INFO) {
		const newState = Object.assign({}, state)
		newState.workInfo = action.data
		return newState
	}
	if(action.type === ADD_CONPANY) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.companyList.push(action.data)
		return newState
	}
	if(action.type === DEL_CONPANY) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.companyList.map((item, index) => {
			if(item.id == action.data.id){
				newState.companyList.splice(index,1)
			}
		})
		return newState
	}
	if(action.type === ADD_CONPANY_LIST) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.companyList = action.data
		return newState
	}
	if(action.type === SET_CURRENT_LOGIN) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.currentLogin = action.data
		return newState
	}
	return state
}
export default baseInfo